import React from "react";

export enum DownloadFormatType {
  JSON = "json",
  CSV = "csv",
}
type DownloadFormatProps = {
  format: DownloadFormatType;
  onChange: (format: DownloadFormatType) => void;
};

const DownloadFormat: React.FC<DownloadFormatProps> = ({ format, onChange }) => (
  <div>
    <div className="flex flex-wrap items-center space-x-6">
      <label className="flex items-center space-x-2 text-sm sm:text-base">
        <input
          type="radio"
          name="dataFormat"
          value="json"
          checked={format === DownloadFormatType.JSON}
          onChange={() => onChange(DownloadFormatType.JSON)}
          className="form-radio text-blue-600"
        />
        <span className="text-gray-700">{DownloadFormatType.JSON.toUpperCase()}</span>
      </label>
      <label className="flex items-center space-x-2 text-sm sm:text-base">
        <input
          type="radio"
          name="dataFormat"
          value="csv"
          checked={format === DownloadFormatType.CSV}
          onChange={() => onChange(DownloadFormatType.CSV)}
          className="form-radio text-blue-600"
        />
        <span className="text-gray-700">{DownloadFormatType.CSV.toUpperCase()}</span>
      </label>
    </div>
  </div>
);

export default DownloadFormat;
